import type { CupomItem } from "../models/cupomEstabelecimentoFornecedorModel"

export type TipoDesconto = "percentual" | "valor" | "frete"

/** Cupom de "apenas frete grátis" = frete grátis sem valor de desconto. */
export function tipoDoCupom(c: CupomItem): TipoDesconto {
    if (c.freteGratis && !c.valor) return "frete"
    return c.percentual ? "percentual" : "valor"
}

export function aplicarTipo(c: CupomItem, tipo: TipoDesconto): CupomItem {
    if (tipo === "frete") {
        return { ...c, valor: 0, percentual: false, maximoDesconto: null, freteGratis: true }
    }
    const veioDeFrete = tipoDoCupom(c) === "frete"
    return {
        ...c,
        percentual: tipo === "percentual",
        maximoDesconto: tipo === "percentual" ? c.maximoDesconto : null,
        freteGratis: veioDeFrete ? false : c.freteGratis,
        valor: veioDeFrete ? 10 : c.valor,
    }
}

export function formatarMoeda(v: number) {
    return v.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
}

export function descreverDesconto(c: CupomItem) {
    const tipo = tipoDoCupom(c)
    if (tipo === "frete") return "Apenas frete grátis"
    if (tipo === "percentual") return `${c.valor.toLocaleString("pt-BR")}% de desconto`
    return `${formatarMoeda(c.valor)} de desconto`
}

export function novoCupom(localId: number): CupomItem {
    return {
        localId,
        id: null,
        cupomId: null,
        nomeCupom: "",
        valor: 10,
        percentual: true,
        quantidadePorCliente: 1,
        quantidadeMaxima: 9999,
        valorMinimoPedido: null,
        maximoDesconto: null,
        apenasPrimeiraCompra: true,
        automatico: true,
        ativo: true,
        freteGratis: false,
        appSiteTodos: 0,
        validadeDias: 30,
        fimCupomTimestamp: null,
        visivelTelaInicial: false,
        horarioAlmoco: false,
        exigirFacebookParaDesconto: false,
        exigirEnderecoUnicoParaDesconto: false,
        exigirCpfParaDesconto: false,
        telefoneCliente: null,
        descricao: "",
        olharListaClientes: false,
        quantidadeUtilizada: 0,
    }
}

export function validarCodigo(c: CupomItem, outros: CupomItem[]): string | null {
    const codigo = c.nomeCupom.trim()
    if (!codigo) return "Informe o código do cupom."
    if (outros.some(o => o.localId !== c.localId && o.nomeCupom.trim().toUpperCase() === codigo.toUpperCase())) {
        return "Já existe um cupom com esse código."
    }
    return null
}

export function validarDesconto(c: CupomItem): string | null {
    const tipo = tipoDoCupom(c)
    if (tipo === "frete") return null
    if (!(c.valor > 0)) return "O valor do desconto deve ser maior que zero."
    if (tipo === "percentual" && c.valor > 100) return "O percentual não pode passar de 100%."
    return null
}

export function validarRegras(c: CupomItem): string | null {
    if (c.validadeDias === 0 && !c.fimCupomTimestamp) {
        return "Informe a data de validade para o cupom personalizado."
    }
    if (!(c.quantidadePorCliente > 0)) return "A quantidade por cliente deve ser maior que zero."
    return null
}

export function validarCupom(c: CupomItem, outros: CupomItem[]): string | null {
    return validarCodigo(c, outros) ?? validarDesconto(c) ?? validarRegras(c)
}

/** Expirado = data fim (calculada pelo backend a partir da validade) já passou. */
export function estaExpirado(c: CupomItem, agora = Date.now()) {
    return c.fimCupomTimestamp !== null && c.fimCupomTimestamp < agora
}

export function formatarData(ts: number) {
    return new Date(ts).toLocaleDateString("pt-BR")
}
